import { Button, Spinner, TextInput } from 'flowbite-react';
import React, { useRef, useState } from 'react'
import client from '../../api/client';
import showToast from '../CustomToast/toastHelper';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import CustomModal from '../Modal/CustomModal';
import CreatePinModal from '../CreatePinModal/CreatePinModal';

interface ConfirmPinModalProps {
    // oldPin: string,
    // //newPin: string,
    onComplete: () => void,
    onBackPress: () => void
}
const ConfirmPinModal = ({ onComplete, onBackPress }: ConfirmPinModalProps) => {
    const PIN_LENGTH = 4;
    const [pin, setPin] = useState<string[]>(new Array(PIN_LENGTH).fill(''));
    const [loading, setLoading] = useState<boolean>(false);
    const confirmPinRefs = useRef<(HTMLInputElement | null)[]>([]);
    const [openCreatePinModal, setOpenCreatePinModal] = useState<boolean>(false)
    const [showOtp, setShowOtp] = useState<boolean>(false)
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const { value } = e.target;
        if (value.length > 1 || isNaN(Number(value))) return;

        const newOtp = [...pin];
        newOtp[index] = value;
        setPin(newOtp);

        if (value && index < PIN_LENGTH - 1) {
            confirmPinRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === 'Backspace' && !pin[index] && index > 0) {
            confirmPinRefs.current[index - 1]?.focus();
        }
    };

    // const CompleteChangePinProcess = async () => {
    //     setLoading(true)
    //     const payload = {
    //         oldPin,
    //         newPin,
    //         confirmNewPin: pin.join('')
    //     }
    //     try {
    //         const response = await client.post('/subsidiary/dashboard/pin/change', payload);
    //         console.log(response.data.data);

    //         const message = response?.data?.message;
    //         showToast(message, "success")
    //         onComplete()

    //     } catch (err: any) {
    //         if (err?.response?.data?.message === 'Please login again') {
    //             sessionStorage.clear();
    //             window.location.href = '/';
    //         } else {
    //             const message = err?.response?.data?.message;
    //             console.error('error getting data', err);
    //             showToast(message, "error");
    //         }
    //     }
    //     finally {
    //         setLoading(false)
    //     }
    // }
    return (
        <div className="flex flex-col items-center justify-center p-6 w-full max-w-sm mx-auto rounded-lg">
            <p className='text-center text-md font-semibold mb-2'>Enter Current PIN</p>

            <div>
                <p className='text-xs mb-2'>{'Kindly provide your current PIN'}</p>
            </div>
            <div className='flex gap-3 mb-2'>
                {pin.map((digit, index) => (
                    <TextInput
                        key={`confirm-${index}`}
                        type={showOtp ? 'text' : 'password'}
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        ref={(el) => (confirmPinRefs.current[index] = el)}
                        className="w-12 text-center text-xl font-bold border border-gray-300 rounded-lg focus:border-blue-500"
                    />
                ))}
            </div>
            {/* Toggle Visibility */}
            <div className="flex justify-center items-center mb-3">
                <button type="button" onClick={() => setShowOtp(!showOtp)} className="p-2 w-8 h-8 flex items-center justify-center rounded-md">
                    {showOtp ? <FaEyeSlash className="w-6 h-6 text-gray-600" /> : <FaEye className="w-6 h-6 text-gray-600" />}
                </button>
            </div>
            <div className="flex gap-4">
                <Button onClick={() => onBackPress()} className="bg-white text-black hover:text-white border-2 border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-md">
                    Back
                </Button>
                <Button onClick={() => setOpenCreatePinModal(true)} className="bg-custom-button-green text-white px-4 py-2 rounded-md hover:bg-green-600 transition">
                Next
                </Button>
            </div>
            <CustomModal size='md' dismissible show={openCreatePinModal} icon='' onClose={() => setOpenCreatePinModal(false)}>
                {/* <SecurityQuestions otp={otp} pin={pin.join('')} confirmPin={confirmPin.join('')} close={() => setOpenSecurityModal(false)} /> */}
                <CreatePinModal oldPin={pin.join('')} type='change-pin' closeAllModals={()=>onComplete()} close={()=>setOpenCreatePinModal(false)} onSuccess={()=>onComplete()} message='Choose a 4-digit pin and confirm' buttonText='Change PIN' />
            </CustomModal>
        </div>
    )
}

export default ConfirmPinModal
